<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div class="email-application" style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ show: mqShallShowLeftSidebar }"
      @click="mqShallShowLeftSidebar = false"
    />

    <!-- Email List -->
    <div class="email-app-list">
      <!-- App Searchbar Header -->
      <div class="app-fixed-search d-flex align-items-center">
        <!-- Toggler -->
        <div class="sidebar-toggle d-block d-lg-none ml-1">
          <feather-icon
            icon="MenuIcon"
            size="21"
            class="cursor-pointer"
            @click="mqShallShowLeftSidebar = true"
          />
        </div>

        <!-- Searchbar -->
        <div class="d-flex align-content-center justify-content-between w-100">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" class="text-muted" />
            </b-input-group-prepend>
            <b-form-input
              :value="searchQuery"
              placeholder="بحث ..."
              @input="updateRouteQuery"
            />
            <b-input-group-append>
              <b-spinner v-show="loading" variant="info" class="mt-25 mx-50" />
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <!-- Emails List -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="email-user-list scroll-area"
      >
        <ul class="email-media-list">
          <b-media
            v-for="(email, i) in emails"
            :key="email.id"
            tag="li"
            no-body
            @click="updateEmailViewData(email.id)"
          >
            <b-media-aside class="media-left mr-1">
              <b-avatar
                :src="email.sender ? email.sender.logo : ''"
                size="60"
                variant="primary"
              />
            </b-media-aside>

            <b-media-body>
              <div class="mail-details">
                <div class="mail-items">
                  <h5>{{ email.title }}</h5>
                  <small class="text-truncate" v-if="email.receivers">{{
                    email.receivers.name_ar
                  }}</small>
                  <small class="text-truncate" v-if="email.sender">{{
                    email.sender.name_ar
                  }}</small>
                </div>
                <div class="mail-meta-item">
                  <span class="mail-date mx-50">
                  {{ formatDate(email.updated_at, 'YYYY-MM-DD h:mm A') }}</span>
                  <div class="mail-date mx-50">
                    {{
                      email.replies_count === 0
                        ? ""
                        : email.replies_count === 1
                        ? "رد واحد"
                        : email.replies_count <= 10
                        ? `${email.replies_count} ردود`
                        : `${email.replies_count} رداً`
                    }}
                  </div>
                </div>
              </div>

              <div class="mail-message d-flex">
                <p
                  ref="messageContent"
                  style="height: 25px; overflow: hidden"
                  class="text-truncate mb-0 message-content-preview"
                  v-html="email.content"
                ></p>
              </div>
            </b-media-body>
          </b-media>
        </ul>

        <div class="no-results" :class="{ show: !emails.length }">
          <h5>لا توجد عناصر لعرضها .</h5>
        </div>
      </vue-perfect-scrollbar>
    </div>

    <!-- Email View/Detail -->
    <email-view
      :class="{ show: showEmailDetails }"
      :email-view-data="emailViewData"
      :opended-email-meta="opendedEmailMeta"
      @close-email-view="showEmailDetails = false"
      @move-email-to-folder="moveOpenEmailToFolder"
      @toggle-email-starred="toggleStarred(emailViewData)"
      @update-email-label="updateOpenEmailLabel"
      @mark-email-unread="markOpenEmailAsUnread"
      @change-opened-email="changeOpenedEmail"
      @toggle-reply-modal="
        isReply = true;
        shallShowEmailComposeModal = true;
      "
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <email-left-sidebar
        :shall-show-email-compose-modal.sync="shallShowEmailComposeModal"
        :emails-meta="emailsMeta"
        :class="{ show: mqShallShowLeftSidebar }"
        @close-left-sidebar="
          isReply = false;
          mqShallShowLeftSidebar = false;
        "
      />
    </portal>

    <!-- Compose Email Modal -->
    <email-compose
      :messageId.sync="messageId"
      :isReply="isReply"
      @emailSent="fetchEmails"
      @replySent="updateEmailViewData(messageId)"
      v-model="shallShowEmailComposeModal"
    />
  </div>
</template>

<script>
import store from "@/store";
import {
  ref,
  onUnmounted,
  computed,
  watch,
  // ref, watch, computed, onUnmounted,
} from "@vue/composition-api";
import { formatDate } from "@/utils/utils";
import {
  BFormInput,
  BSpinner,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { filterTags } from "@core/utils/filter";
import { useRouter } from "@core/utils/utils";
import { useResponsiveAppLeftSidebarVisibility } from "@core/comp-functions/ui/app";
import EmailLeftSidebar from "../components/EmailLeftSidebar.vue";
import EmailView from "../components/EmailView.vue";
import emailStoreModule from "../emailStoreModule";
import useEmail from "../useEmail";
import EmailCompose from "../components/EmailCompose.vue";
import authHelpers from "@/utils/auth-helpers";
export default {
  components: {
    BFormInput,
    BSpinner,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,

    // 3rd Party
    VuePerfectScrollbar,

    // App SFC
    EmailLeftSidebar,
    EmailView,
    EmailCompose,
  },
  methods: {
     
    formatDate(value , formFormat) {
      return formatDate(value, formFormat);
    },
  },
  mounted() {},
  created() {
    // Set `appConfig` when page/SFC is created
    if (authHelpers.isUserMinistry())
      this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", true);
  },
  setup() {
    const EMAIL_APP_STORE_MODULE_NAME = "Messaging";

    // Register module
    if (!store.hasModule(EMAIL_APP_STORE_MODULE_NAME))
      store.registerModule(EMAIL_APP_STORE_MODULE_NAME, emailStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(EMAIL_APP_STORE_MODULE_NAME))
        store.unregisterModule(EMAIL_APP_STORE_MODULE_NAME);
    });

    const { route, router } = useRouter();
    const { resolveLabelColor } = useEmail();

    // Route Params
    const routeParams = computed(() => route.value.params);
    watch(routeParams, () => {
      // eslint-disable-next-line no-use-before-define
      fetchEmails();
    });

    // Emails & EmailsMeta
    const emails = ref([]);
    const emailsMeta = ref({});

    const isReply = ref(false);
    const messageId = ref(null);
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    // Search Query
    const routeQuery = computed(() => route.value.query.q);
    //loading
    const loading = computed(() => store.getters["Messaging/loading"]);

    const searchQuery = ref(routeQuery.value);
    watch(routeQuery, (val) => {
      searchQuery.value = val;
    });
    // eslint-disable-next-line no-use-before-define
    watch(searchQuery, () => fetchEmails());
    const updateRouteQuery = (val) => {
      const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));

      if (val) currentRouteQuery.q = val;
      else delete currentRouteQuery.q;

      router.replace({ name: route.name, query: currentRouteQuery });
    };

    const fetchEmails = () => {
      store
        .dispatch("Messaging/fetchEmails", {
          q: searchQuery.value,
          type: router.currentRoute.params.folder || "received",
        })
        .then((response) => {
          emails.value = response.data.data;
        });
    };

    fetchEmails();

    // ------------------------------------------------
    // Mail Selection
    // ------------------------------------------------
    const selectedEmails = ref([]);
    const toggleSelectedMail = (mailId) => {
      const mailIndex = selectedEmails.value.indexOf(mailId);

      if (mailIndex === -1) selectedEmails.value.push(mailId);
      else selectedEmails.value.splice(mailIndex, 1);
    };
    const selectAllEmailCheckbox = computed(
      () =>
        emails.value &&
        emails.value.length &&
        emails.value.length === selectedEmails.value.length
    );
    const isSelectAllEmailCheckboxIndeterminate = computed(
      () =>
        Boolean(selectedEmails.value.length) &&
        emails.value.length !== selectedEmails.value.length
    );
    const selectAllCheckboxUpdate = (val) => {
      selectedEmails.value = val ? emails.value.map((mail) => mail.id) : [];
    };
    // ? Watcher to reset selectedEmails is somewhere below due to watch dependecy fullfilment

    // ------------------------------------------------
    // Mail Actions
    // ------------------------------------------------
    const toggleStarred = (email) => {
      store
        .dispatch("Messaging/updateEmail", {
          emailIds: [email.id],
          dataToUpdate: { isStarred: !email.isStarred },
        })
        .then(() => {
          // eslint-disable-next-line no-param-reassign
          email.isStarred = !email.isStarred;
        });
    };

    const moveSelectedEmailsToFolder = (folder) => {
      store
        .dispatch("Messaging/updateEmail", {
          emailIds: selectedEmails.value,
          dataToUpdate: { folder },
        })
        .then(() => {
          fetchEmails();
        })
        .finally(() => {
          selectedEmails.value = [];
        });
    };

    const updateSelectedEmailsLabel = (label) => {
      store
        .dispatch("Messaging/updateEmailLabels", {
          emailIds: selectedEmails.value,
          label,
        })
        .then(() => {
          fetchEmails();
        })
        .finally(() => {
          selectedEmails.value = [];
        });
    };

    const markSelectedEmailsAsUnread = () => {
      store
        .dispatch("Messaging/updateEmail", {
          emailIds: selectedEmails.value,
          dataToUpdate: { isRead: false },
        })
        .then(() => {
          fetchEmails();
        })
        .finally(() => {
          selectedEmails.value = [];
        });
    };

    // ------------------------------------------------
    // Email Details
    // ------------------------------------------------
    const showEmailDetails = ref(false);
    const emailViewData = ref({});
    const opendedEmailMeta = computed(() => {
      const openedEmailIndex = emails.value.findIndex(
        (e) => e.id === emailViewData.value.id
      );
      return {
        hasNextEmail: Boolean(emails.value[openedEmailIndex + 1]),
        hasPreviousEmail: Boolean(emails.value[openedEmailIndex - 1]),
      };
    });
    const updateEmailViewData = (id) => {
      // Mark email is read
      messageId.value = id;
      store
        .dispatch("Messaging/fetchEmailById", id)
        .then((res) => {
          emailViewData.value = res.data.data;
        })
        .finally(() => {
          showEmailDetails.value = true;
        });
    };
    const moveOpenEmailToFolder = (folder) => {
      selectedEmails.value = [emailViewData.value.id];
      moveSelectedEmailsToFolder(folder);
      selectedEmails.value = [];
      showEmailDetails.value = false;
    };
    const updateOpenEmailLabel = (label) => {
      selectedEmails.value = [emailViewData.value.id];
      updateSelectedEmailsLabel(label);

      // Update label in opened email
      const labelIndex = emailViewData.value.labels.indexOf(label);
      if (labelIndex === -1) emailViewData.value.labels.push(label);
      else emailViewData.value.labels.splice(labelIndex, 1);

      selectedEmails.value = [];
    };

    const markOpenEmailAsUnread = () => {
      selectedEmails.value = [emailViewData.value.id];
      markSelectedEmailsAsUnread();

      selectedEmails.value = [];
      showEmailDetails.value = false;
    };

    const changeOpenedEmail = (dir) => {
      const openedEmailIndex = emails.value.findIndex(
        (e) => e.id === emailViewData.value.id
      );
      const newEmailIndex =
        dir === "previous" ? openedEmailIndex - 1 : openedEmailIndex + 1;
      emailViewData.value = emails.value[newEmailIndex];
    };

    // * If someone clicks on filter while viewing detail => Close the email detail view
    watch(routeParams, () => {
      showEmailDetails.value = false;
    });

    // * Watcher to reset selectedEmails
    // ? You can also use showEmailDetails (instead of `emailViewData`) but it will trigger execution twice in this case
    // eslint-disable-next-line no-use-before-define
    watch([emailViewData, routeParams], () => {
      selectedEmails.value = [];
    });

    // Compose
    const shallShowEmailComposeModal = ref(false);

    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility();

    return {
      // UI
      perfectScrollbarSettings,

      // Emails & EmailsMeta
      emails,
      emailsMeta,

      // Mail Selection
      selectAllEmailCheckbox,
      isSelectAllEmailCheckboxIndeterminate,
      selectedEmails,
      toggleSelectedMail,
      selectAllCheckboxUpdate,

      // Mail Actions
      toggleStarred,
      moveSelectedEmailsToFolder,
      updateSelectedEmailsLabel,
      markSelectedEmailsAsUnread,

      // Email Details
      showEmailDetails,
      emailViewData,
      opendedEmailMeta,
      updateEmailViewData,
      moveOpenEmailToFolder,
      updateOpenEmailLabel,
      markOpenEmailAsUnread,
      changeOpenedEmail,

      // Search Query
      searchQuery,
      updateRouteQuery,

      // UI Filters
      filterTags,

      // useEmail
      resolveLabelColor,

      // Compose
      shallShowEmailComposeModal,

      // Left Sidebar Responsiveness
      mqShallShowLeftSidebar,
      loading,
      fetchEmails,
      isReply,
      messageId,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-email.scss";
@media print {
  .go-back,
  .print-btn,
  .reply-row,
  .b-avatar {
    display: none;
  }

  .email-subject {
    font-size: 22px;
  }

  .mail-message {
    font-size: 18px;
  }
  .mail-ngo-name,
  .mail-user-name {
    font-size: 20px;
  }
}
</style>
